export default () => {
    if (
        !document.documentElement.lang ||
        !document.documentElement.lang.length
    ) {
        return 'de'
    } else {
        if (document.documentElement.lang.indexOf('-') !== -1) {
            const locale = document.documentElement.lang.split('-')[0]
            const country = document.documentElement.lang.split('-')[1]
            if (locale === 'en') {
                return locale
            } else {
                return `${locale}-${country.toUpperCase()}`
            }
        } else {
            return document.documentElement.lang
        }
    }
}
